import { Epic, ofType } from 'redux-observable';
import { from, of } from 'rxjs';
import { catchError, delay, mergeMap, switchMap } from 'rxjs/operators';

import {
  COMPLETE_BULK_UPLOAD_FILES_FAILURE,
  COMPLETE_BULK_UPLOAD_FILES_REQUEST,
  COMPLETE_BULK_UPLOAD_FILES_SUCCESS,
} from '../../../actions/types';
import { completeBulkUploadFilesAction } from '../../../actions';
import { CompleteBatchReportUploadOutput } from '@amzn/coral_com-amazon-transreportscenterservice';
import { addNotification, closeModalAction } from '../../../actions/ui';
import {
  DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
  NotificationTypeEnum,
  UPLOAD_FILES_MODAL,
  UPLOAD_REPORT_MODAL,
} from '../../../actions/ui/types';
import { BACKEND_SYNC_DELAY } from '../../../constants';

export const completeBulkUploadFilesEpic: Epic = (action$, state$, { api }) =>
  action$.pipe(
    ofType(COMPLETE_BULK_UPLOAD_FILES_REQUEST),
    switchMap(({ payload }) => {
      const { completeBatchReportUploadInput } = payload;

      return from(
        api.reportsCenterService
          .completeBatchReportUpload(completeBatchReportUploadInput)
          .pipe(
            delay(BACKEND_SYNC_DELAY),
            mergeMap(
              (
                completeBatchReportUploadOutput: CompleteBatchReportUploadOutput
              ) => {
                return of(
                  completeBulkUploadFilesAction.success({
                    completeBatchReportUploadOutput,
                  }),
                  closeModalAction({
                    type: UPLOAD_FILES_MODAL,
                  }),
                  closeModalAction({
                    type: UPLOAD_REPORT_MODAL,
                  }),
                  addNotification({
                    type: NotificationTypeEnum.SUCCESS,
                    action: COMPLETE_BULK_UPLOAD_FILES_SUCCESS,
                    body: 'complete_upload_files_notifications.success',
                    timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
                  })
                );
              }
            ),
            catchError((err) =>
              of(
                completeBulkUploadFilesAction.failure(err),
                addNotification({
                  type: NotificationTypeEnum.ERROR,
                  action: COMPLETE_BULK_UPLOAD_FILES_FAILURE,
                  body: 'complete_upload_files_notifications.failure',
                  timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
                })
              )
            )
          )
      );
    })
  );

export default completeBulkUploadFilesEpic;
